export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";
export const DEFAULT_TIME_FORMAT = "HH:mm";
export const FULL_TIME_FORMAT = "HH:mm:ss";
export const DEFAULT_DATE_FORMAT_WITH_TIME = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
export const DEFAULT_DATE_FORMAT_WITH_FULL_TIME = `${DEFAULT_DATE_FORMAT} ${FULL_TIME_FORMAT}`;
export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const ISO_DATE_FORMAT_WITH_FULL_TIME = `${ISO_DATE_FORMAT} ${FULL_TIME_FORMAT}`;
export const SHORT_DATE_FORMAT = "D/M/YYYY";
export const US_DATE_FORMAT = "MM/DD/YYYY";
export const FULL_MONTH_NAME_DATE_FORMAT = "MMMM D, YYYY";
export const COMMENT_DATE_FORMAT_WITH_TIME = `${DEFAULT_TIME_FORMAT}, DD MMMM YYYY`;
